export default  (
    value,
    prefix,
    percentage,
    potency,
    translate
) => {
    if (typeof value === "undefined" || value === null) {
        return "-";
    }

    const suffix = `${percentage ? percentage + " " : ""}${renderPotency(
        potency,
        translate
    )}`;

    const result = `${prefix ? prefix : ""}${(value).toLocaleString('en-us')}${
        suffix ? suffix : ""
    }`;
    return result;
};

const renderPotency = (potency, translate) => {
    if (potency === null) return "";

    const potencyTranslations = translate("Potency");
    let result = "";
    if (potencyTranslations && potencyTranslations.hasOwnProperty(potency)) {
        result = potencyTranslations[potency];
    }
    return result;
};
